import { subscriptionsSlice } from './subscriptions.slice';
import * as actions from './actions';
import * as selectors from './selectors';
export const subscriptionsActions = {
  ...subscriptionsSlice.actions,
  ...actions,
};

export const subscriptionsSelectors = {
  ...selectors,
};
